var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUbipin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.459,
    height: 90.083,
    viewBox: "0 0 70.459 90.083",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-32 -93)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.515,
    height: 90.083,
    transform: "translate(32 93)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32 93)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.576,16.108A35.229,35.229,0,0,0,19.754,65.93h0L44.665,90.841,69.576,65.931A35.23,35.23,0,0,0,69.576,16.108ZM61.856,46.96c0,13.073-7.009,17.067-17.191,17.043-10.182.024-17.191-3.97-17.191-17.043V23.84H37.847v25.2q0,3.555,2.075,5.186a7.716,7.716,0,0,0,9.485,0q2.077-1.628,2.075-5.186V28.88a4.983,4.983,0,0,1,1.408-3.558,4.79,4.79,0,0,1,3.631-1.482h5.334Z",
    transform: "translate(-9.435 -5.79)",
    fill: "#00b2ff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbipin);
export default __webpack_public_path__ + "static/media/ubipin.18c38ae522f9a7b22f61b156dba2f555.svg";
export { ForwardRef as ReactComponent };